import { useEffect } from 'react'
import Avatar from "@components/avatar"
import { Link } from 'react-router-dom'
import BlankProfile from "@src/assets/images/avatars/avatar-blank.png"
import {
    Row,
    Col,
    Spinner
} from "reactstrap"
import { MapPin, Gift, Users, Calendar, ArrowRight } from "react-feather"
import { useDispatch, useSelector } from 'react-redux'
import { getMyCurrentOpportunities } from '@store/actions/brandsDashboard'
import '@styles/react/apps/app-invoice.scss'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import queryString from "query-string"

const RecommendedOpportunities = () => {
    const dispatch = useDispatch()

    const {
        brandRecOppLoading,
        brandRecOppFullFill,
        brandRecOppError
    } = useSelector(state => state.brandsDashboardSlice)

    useEffect(() => {
        dispatch(getMyCurrentOpportunities(""))
    }, [])

    const handleCustomPagination = pageUrl => {
        const parsed = queryString.parseUrl(pageUrl)
        const pageNo = parsed?.query?.page
        dispatch(getMyCurrentOpportunities(`?page=${pageNo}`))
    }

    return (
        <>
            {brandRecOppLoading ? (
                <div className="d-flex justify-content-center" style={{ height: '200px' }}>
                    <div className="align-self-center">
                        <Spinner color='primary' />
                    </div>
                </div>
            ) : (
                brandRecOppFullFill?.data?.length > 0 && (
                    <div className="figma-split-card" id="brand-recommended-pitches-card">
                        <div className="figma-section-label mb-2">
                            RECOMMENDED PARTNERSHIP PITCHES
                        </div>
                        <Row className="match-height">
                            {brandRecOppFullFill?.data?.map((currentData, index) => (
                                <Col xs="12" sm="6" md="6" lg="3" key={`recommended-opportunities-${index}`} className="mb-2">
                                    <div className="figma-opportunity-card h-100 d-flex flex-column">
                                        <Link to={`/dashboard/brands/nutrition-detail/${currentData.id}`} className="opportunity-card-link">
                                            <h5 className="opportunity-title" title={currentData?.event_title}>
                                                {currentData?.event_title || 'N/A'}
                                            </h5>
                                            <div className="opportunity-meta-grid">
                                                {currentData?.country && (
                                                    <div className="meta-item">
                                                        <MapPin size={13} className="meta-icon" />
                                                        <span className="meta-text text-truncate">{currentData.country}</span>
                                                    </div>
                                                )}
                                                {currentData?.type_of_event && (
                                                    <div className="meta-item">
                                                        <Gift size={13} className="meta-icon" />
                                                        <span className="meta-text text-truncate">{currentData.type_of_event}</span>
                                                    </div>
                                                )}
                                                {currentData?.exp_reach && (
                                                    <div className="meta-item">
                                                        <Users size={13} className="meta-icon" />
                                                        <span className="meta-text text-truncate">{currentData.exp_reach} reach</span>
                                                    </div>
                                                )}
                                                {currentData?.start_date && (
                                                    <div className="meta-item">
                                                        <Calendar size={13} className="meta-icon" />
                                                        <span className="meta-text text-truncate">{currentData.start_date}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="opportunity-footer mt-auto pt-1 border-top d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center overflow-hidden mr-50">
                                                    <Avatar
                                                        img={currentData?.profile_img || BlankProfile}
                                                        className="mr-50 flex-shrink-0"
                                                        imgHeight="28"
                                                        imgWidth="28"
                                                    />
                                                    <span className="organizer-name text-truncate">
                                                        {currentData?.organizer || 'Dietitian'}
                                                    </span>
                                                </div>
                                                <span className="view-pitch-arrow text-primary flex-shrink-0">
                                                    <ArrowRight size={14} />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                        <Row className="pt-1 justify-content-center">
                            <Col md="12" className="d-flex justify-content-center">
                                <CustomPagination pageLinks={brandRecOppFullFill?.pages}
                                                  onPaginationClick={handleCustomPagination} />
                            </Col>
                        </Row>
                    </div>
                )
            )}
        </>
    )
}

export default RecommendedOpportunities
